import { render, staticRenderFns } from "./DocumentRepositoryManager.vue?vue&type=template&id=287921b6&scoped=true"
import script from "./DocumentRepositoryManager.vue?vue&type=script&lang=js"
export * from "./DocumentRepositoryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287921b6",
  null
  
)

export default component.exports